export const COLETA_TARDIA = {
  AGUARDANDO_LOJA: "AGUARDANDO_LOJA",
  AGUARDANDO_SAL: "AGUARDANDO_SAL",
};

export const isAwaitingStoreConfirmation = (pedido) =>
  !!pedido && pedido.coletaTardia === COLETA_TARDIA.AGUARDANDO_LOJA;

export const isAwaitingSAL = (pedido) =>
  !!pedido && pedido.coletaTardia === COLETA_TARDIA.AGUARDANDO_SAL;
